import React from "react";

import { Footer, Navbar2 } from "../components";

function EventsPage(props) {
  return (
    <div className="h-full">
      <div className="max-w-7xl mx-auto">
        <Navbar2 />
      </div>
      <h1 className="text-center font-montserrat font-bold text-4xl md:text-5xl lg:text-7xl text-mix-400 my-64">
        Event Listings Will Come Soon...
      </h1>
      <Footer support />
    </div>
  );
}

export default EventsPage;
